import { Search } from '@doist/icons/product-ui';
import { Divider, Text } from '@doist/marketist';
import { ProductUIField } from 'components/product-ui/product-ui-field/product-ui-field';
import { useTranslation } from 'next-i18next';
import { ProductUIButton } from '../product-ui-button/product-ui-button';
import { ProductUISkeletonText } from '../product-ui-skeleton-text/product-ui-skeleton-text';
import css from './product-ui-member-list.module.css';
export type ProductUIMemberListProps = {
  permissions: React.ReactNode[];
  ctaLabel?: string;
  title?: string;
};
export function ProductUIMemberList({
  permissions,
  ctaLabel,
  title
}: ProductUIMemberListProps) {
  const {
    t
  } = useTranslation('productui');
  return <div className={css.container} data-sentry-component="ProductUIMemberList" data-sentry-source-file="product-ui-member-list.tsx">
            <Divider data-sentry-element="Divider" data-sentry-source-file="product-ui-member-list.tsx" />

            <div className={css.controls}>
                <ProductUIButton variant="primary" data-sentry-element="ProductUIButton" data-sentry-source-file="product-ui-member-list.tsx">
                    {ctaLabel ? ctaLabel : t('invitePeople')}
                </ProductUIButton>
                <ProductUIField startIcon={<Search />} data-sentry-element="ProductUIField" data-sentry-source-file="product-ui-member-list.tsx">
                    <div className={css.fieldSkeleton}>
                        <ProductUISkeletonText width="60" data-sentry-element="ProductUISkeletonText" data-sentry-source-file="product-ui-member-list.tsx" />
                    </div>
                </ProductUIField>
            </div>

            <div className={css.members}>
                <Text size="minor-base" weight="semibold" tag="span" data-sentry-element="Text" data-sentry-source-file="product-ui-member-list.tsx">
                    {title ? title : t('members')}
                </Text>
                {permissions.map((permission, i) => <div key={`permission-${i}`}>
                        <div className={css.permission}>{permission}</div>
                        <Divider />
                    </div>)}
            </div>
        </div>;
}